import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 70,
  },
  {
    title: "lastName",
    key: "lastName",
    dataIndex: "lastName",
    ellipsis: true,
    width: 100,
  },
  {
    title: "firstName",
    key: "firstName",
    dataIndex: "firstName",
    ellipsis: true,
    width: 100,
  },
  {
    title: "fiscalCode",
    key: "fiscalCode",
    dataIndex: "fiscalCode",
    ellipsis: true,
    width: 100,
  },
  {
    title: "email",
    key: "email",
    dataIndex: "email",
    ellipsis: true,
    width: 100,
  },
  {
    title: "Numero di telefono",
    key: "phoneNumber",
    dataIndex: "phoneNumber",
    ellipsis: true,
    width: 100,
  },
];

export default function () {

  return (
    <SimpleTablePage
      resource="doctor"
      columns={columns}
    />
  );
}
